import { Box, Paper, Stack, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Cell,
} from "recharts";
import React, { useEffect } from "react";
import {
  blackColor,
  blackShade19,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { useState } from "react";
import { toTitleCase } from "../../../utils/validationUtils";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Paper elevation={3} sx={{ p: 1, borderRadius: 2, bgcolor: whiteColor }}>
        <Typography sx={{ fontWeight: 600, color: blackShade19 }}>
          {toTitleCase(label)}
        </Typography>
        <Box>
          <Typography sx={{ color: "#555" }}>
            Orders: {payload[0].payload.orderCount}
          </Typography>
        </Box>
      </Paper>
    );
  }
  return null;
};

function CRMTopSellingByAreaSection({ rawData }) {
//   const [data, setData] = useState([]);

//   const colors = ["#3e53d9", "#ff6745", "#00e272", "#ff7340", "#32d9c5"];

//   useEffect(() => {
//     const processedData = rawData.map(({ cityState, orderCount }) => ({
//       city: cityState.city.trim(),
//       orderCount,
//     }));

//     setData(processedData);
//   }, [rawData]);

  return (
    <Stack
      sx={{
        border: "1px solid #E1E8F0",
        borderRadius: "12px",
        p: "10px 15px",
        gap: 1,
      }}
    >
      <Typography
        fontSize={13}
        fontWeight={600}
        color={blackColor}
        lineHeight={1.5}
      >
        Total Selling by Area
      </Typography>

      {/* <ResponsiveContainer width="100%" height={170}>
        <BarChart
          data={data}
          margin={{ top: 10, right: 0, left: -30, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="city"
            axisLine={{ stroke: "#000" }}
            tickLine={false}
            tick={{ fill: "#000", fontSize: 12, fontWeight: 400 }}
            interval={0}
            tickFormatter={(city) => toTitleCase(city)?.substring(0, 11)}
          />

          <YAxis
            tickLine={false}
            tick={{ fill: "#000", fontSize: 12 }}
            domain={[0, "dataMax + 5"]}
          />

          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "transparent" }}
          />

          <Bar dataKey="orderCount" barSize={20} radius={[2, 2, 0, 0]}>
            {data?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer> */}
    </Stack>
  );
}

export default CRMTopSellingByAreaSection;
